/**
 * Persistencia en localStorage de qué tours ya vio el usuario.
 * Key único por usuario (prefijo con user_id) para que distintos logins en
 * mismo browser tengan feeds independientes.
 */
const KEY_PREFIX = 'clobi_tour_seen::'

function key(userId: string, tourId: string): string {
  return `${KEY_PREFIX}${userId}::${tourId}`
}

export function markTourSeen(userId: string, tourId: string): void {
  try {
    localStorage.setItem(key(userId, tourId), '1')
  } catch {
    /* localStorage bloqueado — noop */
  }
}

export function isTourSeen(userId: string, tourId: string): boolean {
  try {
    return localStorage.getItem(key(userId, tourId)) === '1'
  } catch {
    return false
  }
}

export function resetTourSeen(userId: string, tourId: string): void {
  try {
    localStorage.removeItem(key(userId, tourId))
  } catch {
    /* noop */
  }
}

export function resetAllTours(userId: string): void {
  try {
    const prefix = `${KEY_PREFIX}${userId}::`
    const toDelete: string[] = []
    for (let i = 0; i < localStorage.length; i++) {
      const k = localStorage.key(i)
      if (k && k.startsWith(prefix)) toDelete.push(k)
    }
    toDelete.forEach(k => localStorage.removeItem(k))
  } catch {
    /* noop */
  }
}
